@if (sidebar.visible) {
  <div class="sidebar-mobile-header">
    <button
      mat-button
      class="sidebar-mobile-toggle"
      type="button"
      [attr.aria-controls]="'sidebar-mobile-menu'"
      [attr.aria-expanded]="mobileMenuVisible"
      [attr.aria-label]="mobileMenuVisible ? 'Close navigation menu' : 'Open navigation menu'"
      (click)="toggleMobileMenu()"
    >
      <mat-icon>{{ mobileMenuVisible ? 'close' : 'menu' }}</mat-icon>
    </button>
    <div class="sidebar-mobile-logo-wrapper">
      <app-logo
        link="/homepage"
        ariaLabel="Constrafor home"
        class="sidebar-mobile-logo"
      />
    </div>
  </div>
  <div
    class="sidebar-mobile-overlay"
    [class.sidebar-mobile-overlay-visible]="mobileMenuVisible"
    (click)="closeMobileMenu()"
  ></div>
  <div
    id="sidebar-mobile-menu"
    class="sidebar-wrapper"
    [class.sidebar-mobile-visible]="mobileMenuVisible"
    (mouseenter)="toggleSidebarMenuHoverState(true)"
    (mouseleave)="toggleSidebarMenuHoverState(false)"
  >
    <div class="sidebar-buttons-wrapper">
      <div class="sidebar-top-section">
        <app-logo
          variant="mark"
          link="/homepage"
          ariaLabel="Constrafor home"
          dataTest="sidebar-logo-link"
          class="logo-wrapper"
        />
        <app-sidebar-button
          name="home"
          [selected]="sidebar.selectedMenuName === 'home'"
        />
        @if (projectsTabVisible) {
          <app-sidebar-button
            name="projects"
            [selected]="sidebar.selectedMenuName === 'projects'"
          />
        }
        <app-sidebar-button
          data-test="financing-sidebar-button"
          name="financing"
          [selected]="sidebar.selectedMenuName === 'financing'"
        />
        <app-sidebar-button
          data-test="project-compliance-sidebar-button"
          name="project-compliance"
          [selected]="sidebar.selectedMenuName === 'project-compliance'"
        />
        <app-sidebar-button
          data-test="cru-sidebar-button"
          name="cru"
          [selected]="sidebar.selectedMenuName === 'cru'"
        />
        @if (integrationsTabVisible) {
          <app-sidebar-button
            name="integrations"
            data-test="integrations-sidebar-button"
            [selected]="sidebar.selectedMenuName === 'integrations'"
          />
        } @else {
          <app-sidebar-button
            name="tools"
            [selected]="sidebar.selectedMenuName === 'tools'"
          />
        }
      </div>
      <div class="sidebar-bottom-section">
        <app-sidebar-account-menu [selectedSideMenuName]="sidebar.selectedMenuName" />
        @if (sidebar.menuVisible) {
          <button
            mat-button
            class="sidebar-menu-collapse-button"
            [title]="sidebar.collapsed ? 'Show sidebar menu' : 'Hide sidebar menu'"
            (click)="sidebar.toggleMenu()"
            (mouseenter)="toggleCollapseButtonHoverState(true)"
            (mouseleave)="toggleCollapseButtonHoverState(false)"
          >
            <mat-icon>{{ sidebar.collapsed ? 'arrow_right' : 'arrow_left' }}</mat-icon>
          </button>
        }
      </div>
    </div>
    @if (sidebar.menuVisible) {
      <app-sidebar-side-menu
        data-test="sidebar-side-menu"
        [class.sidebar-side-menu-overlap]="sidebar.collapsed"
        [class.sidebar-side-menu-overlap-visible]="sidebar.collapsed && sidebarHovered && !collapseButtonHovered"
        [selectedSideMenuName]="sidebar.selectedMenuName"
        [sideMenuMapping]="sidebar.getMenuMapping()"
        [user]="user"
      />
    }
  </div>
}

@if (sidebar.visible) {
  <app-flex gap="0">
    <div class="sidebar-placeholder"></div>
    @if (!sidebar.collapsed && sidebar.menuVisible) {
      <div class="sidebar-menu-placeholder"></div>
    }
  </app-flex>
}
